import React from 'react';
import { Alert, Button } from 'react-bootstrap';

import { useNavigation } from '../../../common/navigation';
import { GetExamDto } from '../../../common/spdCore/autogenerated/spdApiClient';
import { ArticleMode } from '../../../common/spdCore/validation/schemas';

interface AlertConsultationProps {
  exam: GetExamDto | undefined;
  mode?: ArticleMode | null;
}

export const buildConsultations = (exam: GetExamDto | undefined) => {
  const all = [];
  if (exam?.neurologist) {
    all.push(`neurologa (${exam?.neurologistEnded ? '+' : '-'})`);
  }
  if (exam?.ophthalmologist) {
    all.push(`okulisty (${exam?.ophthalmologistEnded ? '+' : '-'})`);
  }
  if (exam?.laryngologist) {
    all.push(`laryngologa (${exam?.laryngologistEnded ? '+' : '-'})`);
  }
  if (exam?.psychiatrist) {
    all.push(`psychiatry (${exam?.psychiatristEnded ? '+' : '-'})`);
  }
  if (exam?.psychologistConsultation) {
    all.push(`psychologa`);
  }

  return all;
};

export const AlertConsultation: React.FC<AlertConsultationProps> = ({
  exam,
  mode,
}) => {
  const nav = useNavigation();

  if (!exam) {
    return null;
  }

  const consultationsRequired =
    !mode || mode === ArticleMode.Doctor || mode === ArticleMode.Psychologist;

  if (!consultationsRequired) {
    return null;
  }

  const consultations = buildConsultations(exam);

  return (
    <Alert
      variant={consultations.length > 0 ? 'warning' : 'light'}
      className="d-flex justify-content-between align-items-center"
    >
      <div>
        Wymagane konsultacje:
        <strong>
          {' '}
          {consultations.length > 0 ? consultations.join(', ') : 'brak'}
        </strong>
      </div>
      <Button
        onClick={() => void nav.examConsultationsEditor(exam?.id || '')}
        variant="outline-secondary"
      >
        Wymagane konsultacje
      </Button>
    </Alert>
  );
};
